import brandTheme from '../../../Assets/Styles/brandTheme'

const {
  colors: { primary },
} = brandTheme()

export const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    zIndex: 2,
  },
  rootPosition: {
    zIndex: 1200,
  },
  fixedButtons: {
    position: 'fixed',
    bottom: 20,
    right: 20,
    zIndex: 1200,
  },
  draggableChat: {
    zIndex: 1020,
  },
  wrapper: {
    background: primary,
    height: 60,
    width: 60,
    cursor: 'pointer',
    color: '#FFFFFF',
    borderRadius: '100%',
    position: 'relative',
    marginTop: '20px',
  },
  message: {
    '& svg': {
      width: '32px',
      height: '32px',
      position: 'absolute',
      top: '17px',
      right: '14px',
    },
  },
  close: {
    '& svg': {
      width: '20px',
      height: '20px',
      position: 'absolute',
      top: '20px',
      right: '20px',
    },
  },
}
